export default __webpack_public_path__ + "static/media/fathers day.404516d2.png";